import { useState } from "react";

export const useCalendarState = () => {
  const [deliveryDate, setDeliveryDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    return tomorrow.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  });

  const [showCalendar, setShowCalendar] = useState(false);

  return {
    deliveryDate,
    setDeliveryDate,
    showCalendar,
    setShowCalendar,
  };
};

